import { useEffect, useState } from 'react'
import { cn } from '@/utils/misc'

type AvatarSize = 'sm' | 'md' | 'lg'

const SIZES: Record<AvatarSize, string> = {
	sm: 'h-9 w-9 text-xs',
	md: 'h-12 w-12 text-sm',
	lg: 'h-20 w-20 text-2xl',
}

export function Avatar({
	src,
	name,
	email,
	size = 'sm',
	className,
}: {
	src?: string | null
	name?: string | null
	email?: string | null
	size?: AvatarSize
	className?: string
}) {
	// Google CDN images return 403 when a Referer header is sent across origins.
	// `referrerPolicy="no-referrer"` avoids that. We still keep an onError
	// fallback in case the URL itself is stale/invalid.
	const [failed, setFailed] = useState(false)

	// Reset failure state when the src changes (e.g. after re-login).
	useEffect(() => {
		setFailed(false)
	}, [src])

	const initials =
		name
			?.split(' ')
			.map((n) => n[0])
			.slice(0, 2)
			.join('')
			.toUpperCase() ||
		email?.[0]?.toUpperCase() ||
		'?'

	return (
		<div
			className={cn(
				'rounded-full bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center text-white font-semibold shrink-0 overflow-hidden',
				SIZES[size],
				className,
			)}
		>
			{src && !failed ? (
				<img
					src={src}
					alt=""
					referrerPolicy="no-referrer"
					onError={() => setFailed(true)}
					className="h-full w-full object-cover"
				/>
			) : (
				initials
			)}
		</div>
	)
}
